// extracted by mini-css-extract-plugin
module.exports = {"company-select-card":"PolicySearchPage_company-select-card__2Sp36","company-card":"PolicySearchPage_company-card__2Ea8j"};